<div id="body">
    <div *ngIf="errors.length > 0" class="error-msg">
        <div *ngFor="let error of errors">
            {{error}}
        </div>
    </div>
    <div *ngIf="loading" class="spinner-wrap">
        <mat-progress-spinner mode="indeterminate" diameter="32"></mat-progress-spinner>
    </div>
    <div class="results-display" *ngIf="carrierOptions.length > 0">
        <div class="customer-container">
            <h2>Customer Freight Rate</h2>
            <div class="customer-billable">
                <div>Freight Rate: ${{ (customerCharges?.rate ?? 0)| number:'1.2-2' }}</div>
                <div>Minimum Rate: ${{ (customerCharges?.min_rate ?? 0)| number:'1.2-2'}}</div>
                <div>Rate Method: {{customerCharges?.rate_method}}</div>
                <div>Rate Unit: {{customerCharges?.rate_unit}}</div>
                <div>Total Freight Rate: ${{ (customerCharges?.total_rate ?? 0)| number:'1.2-2'}}</div>
            </div>
        </div>
        <div class="table-container" *ngIf="historicRatesMarket.length > 0">
            <h2>Historic Market Rates</h2>
            <ag-grid-angular 
                [class]="agTheme"
                style="width: 100%" 
                [rowData]="historicRatesMarket"
                [columnDefs]="historicMarketRatesColumnDefs" 
                [defaultColDef]="defaultColDef"
                rowSelection="single"
                domLayout="autoHeight">
            </ag-grid-angular>
        </div>
        <div class="table-container" *ngIf="historicRatesCustomer.length > 0">
            <h2>Historic Rates - Customer Matches</h2>
            <ag-grid-angular 
                [class]="agTheme"
                style="width: 100%" 
                [rowData]="historicRatesCustomer"
                [columnDefs]="historicRatesColumnDefs" 
                [defaultColDef]="defaultColDef"
                rowSelection="single"
                domLayout="autoHeight">
            </ag-grid-angular>
        </div>
        <div class="table-container" *ngIf="historicRatesCustomer.length > 0">
            <h2>Historic Rates - Carrier Matches</h2>
            <ag-grid-angular 
                [class]="agTheme"
                style="width: 100%" 
                [rowData]="historicRatesCarrier"
                [columnDefs]="historicRatesColumnDefs" 
                [defaultColDef]="defaultColDef"
                rowSelection="single"
                domLayout="autoHeight">
            </ag-grid-angular>
        </div>
        <div class="table-container">
            <h2>Carrier Options</h2>
            <ag-grid-angular 
                [class]="agTheme"
                style="width: 100%" 
                [rowData]="carrierOptions"
                [columnDefs]="carrierColumnDefs" 
                [defaultColDef]="defaultColDef"
                rowSelection="single"
                domLayout="autoHeight"
                (cellClicked)="onCarrierCellClicked($event)">
            </ag-grid-angular>
        </div>
        <div *ngIf="selectedCarrier">
            <div>Selected Carrier: {{selectedCarrier.carrier_name}}</div>
            <button color="primary" mat-raised-button (click)="onCarrierConfirmed()">Set Carrier</button>
        </div>
    </div>

</div>

